import { render, staticRenderFns } from "./InvitationReciept.vue?vue&type=template&id=2bdfe94b&scoped=true&"
import script from "./InvitationReciept.vue?vue&type=script&lang=js&"
export * from "./InvitationReciept.vue?vue&type=script&lang=js&"
import style0 from "./InvitationReciept.vue?vue&type=style&index=0&id=2bdfe94b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bdfe94b",
  null
  
)

export default component.exports